module.exports = __webpack_public_path__ + "assets/favicons/favicon.ico";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=assets/favicons/[name].[ext]!./client/app/assets/favicons/favicon.ico
// module id = 1239
// module chunks = 1